// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W3YA4","col":"styles_col__2a9L2","actions":"styles_actions__3_fgR","conflict":"styles_conflict__cJeRU"};